import { Component, ViewChild, DoCheck, OnInit } from '@angular/core';
import { Configuration } from '../../configuration';
import { Helpers } from '../../helpers';
import { SelectableItem } from '../../models/common/selectableItem';
import { BlockUI } from 'ng-block-ui';
import { DateRangeModel } from '../../models/common/date.range';
import { IPage } from '../../models/common/paging';
import { BookmarkedTenderSummaryDto } from '../../models/tenders/tender.models';
import { NoticeStatus, NoticeEnumsToSelectList } from '../../models/notices/notice.enums';
import { SearchBookmarkedContractAwardsDto } from '../../models/contract.awards/contract.award.models';
import { BookmarkedContractAwardSummaryDto } from '../../models/contract.awards/contract.award.models';
import { ContractAwardService } from '../../services/contract.award.service';
import { TenderTeamMemberSummaryDto } from '../../models/tender.team.members/tender.team.member.models';
import { TenderTeamMemberService } from '../../services/tender.team.member.service';
import { LoggedInUserService } from '../../auth/logged.in.user';
import { CmsDialogService } from '../../services/cms.dialog.service';
import { CmsDialogDto } from '../../models/cms.dialogs/cms.dialogs.models';

@Component({
    selector: 'contractAwards/sharedBookmarked',
    template: require('./shared.bookmarked.component.html'),
    styles: [require('../filter.toggle.shared.css')]
})
export class CaSharedBookmarkedComponent implements OnInit, DoCheck {
    request: SearchBookmarkedContractAwardsDto;
    private previousRequest: SearchBookmarkedContractAwardsDto;

    publishedDate: DateRangeModel;
    statuses: Array<SelectableItem<NoticeStatus>>;
    teamMembers: Array<TenderTeamMemberSummaryDto>;
    options: Array<SelectableItem<string>>;

    results: IPage<BookmarkedContractAwardSummaryDto>;
    resultOptions;

    subscribed: boolean;
    dialogName: string;
    dialogHeader: string;
    dialogBody: string;

    @BlockUI('ca-results-block') private resultsBlock;
    @ViewChild('deleteModal', { static: false }) private deleteModal: any;
    @ViewChild('resultsPage', { static: false }) private resultsView;
    loading: boolean = false;

    constructor(private readonly contractAwardService: ContractAwardService,
        private readonly teamMemberService: TenderTeamMemberService,
        private readonly helpers: Helpers,
        configuration: Configuration,
        loggedInUserService: LoggedInUserService,
        private readonly cmsDialogService: CmsDialogService) {
        this.request = new SearchBookmarkedContractAwardsDto(configuration);
        this.previousRequest = this.helpers.clone(this.request);

        this.publishedDate = new DateRangeModel();

        this.resultOptions = {
            availableButtons: ['print']
        };

        this.statuses = NoticeEnumsToSelectList.getStatuses();
        this.teamMembers = [];

        var user = loggedInUserService.getCurrentUser();
        this.subscribed = !user.canAdHoc('notSubscribed');

        this.options = [
            { text: 'Most Recent', value: 'PublishedDate' },
            { text: 'Start Date', value: 'StartDate' },
            { text: 'End Date', value: 'EndDate' },
            { text: 'Type', value: 'Type' },
            { text: 'Title', value: 'Title' }
        ];

        if (!this.request.sortProperty) {
            this.request.sortProperty = 'PublishedDate';
        }
    }

    ngOnInit() {
        this.loadTeamMembers();

        if (this.subscribed) {
            this.dialogName = 'Shared Bookmarked Awards Info - Subscribed';
        }
        else {
            this.dialogName = 'Shared Bookmarked Awards Info - Not Subscribed';
        }

        this.cmsDialogService.getByDescription(this.dialogName).subscribe((result: CmsDialogDto) => {
            this.dialogHeader = result.header;
            this.dialogBody = result.body;
        });

        this.search();
    }

    ngOnDestroy() {
        $('#shared-bookmarked-awards-info-modal').modal('hide');
        $('#delete-modal').modal('hide');
    }

    private loadTeamMembers() {

        this.teamMemberService.getAll().subscribe((response: Array<TenderTeamMemberSummaryDto>) => {
            this.teamMembers = response;
        });
    }

    ngDoCheck() {
        if (!this.request.equals(this.previousRequest)) {
            this.search();
        }
    }

    search() {
        this.loading = true;
        this.resultsBlock.start();
        const publishedDateDto = this.publishedDate.convertDatesToDto();

        this.request.publishedDateFrom = publishedDateDto.startDate;
        this.request.publishedDateTo = publishedDateDto.endDate;

        if (this.previousRequest.pageNumber === this.request.pageNumber) {
            //We changed something other than the page number, so reset the search to page 1
            this.request.pageNumber = 0;
        }

        this.previousRequest = this.helpers.clone(this.request);

        this.contractAwardService.getSharedBookmarked(this.request).subscribe((results: IPage<BookmarkedContractAwardSummaryDto>) => {
            this.results = results;

            if (this.resultsView) {
                this.resultsView.onSearchComplete();
            }

            this.resultsBlock.stop();
            this.loading = false;
        }, () => {
            this.resultsBlock.stop();
            this.loading = false;
        });
    }

    removeBookmark(award: BookmarkedTenderSummaryDto) {
        this.deleteModal.showAndPopulate(award, award.title);
    }

    confirmRemove(award: BookmarkedTenderSummaryDto) {
        this.deleteModal.clearAndHide();
        this.contractAwardService.removeBookmark(award.bookmarkId).subscribe(() => {
            this.search();
        });
    }

    showInfoDialog() {
        $('#shared-bookmarked-awards-info-modal').modal();
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/contract.awards/shared.bookmarked.component.ts